var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4875 12.2749L2.375 26.3749L0.625 24.6249L14.725 10.5124L16.4875 12.2749ZM22.0875 8.6624L22.825 7.9249L21.8375 6.9374L22.6375 6.1374L20.8625 4.3624L20.0625 5.1624L19.075 4.1749L18.3375 4.9124C16.1625 3.1374 13.7125 1.7124 11.0875 0.712402L10.05 2.9499C12.2375 4.0999 14.25 5.4874 16.125 7.1249L15.5 7.7499L19.25 11.4999L19.875 10.8749C21.5125 12.7499 22.9 14.7624 24.05 16.9499L26.2875 15.9124C25.2875 13.2874 23.8625 10.8374 22.0875 8.6624Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMineActive);
export default __webpack_public_path__ + "static/media/menu-mine-active.bbc9a200a75eb887a44edef9f3432be9.svg";
export { ForwardRef as ReactComponent };